import { render, staticRenderFns } from "./CarActualOwnerForm.vue?vue&type=template&id=3fbf80bc&scoped=true&"
import script from "./CarActualOwnerForm.vue?vue&type=script&lang=js&"
export * from "./CarActualOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./CarActualOwnerForm.vue?vue&type=style&index=0&id=3fbf80bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbf80bc",
  null
  
)

component.options.__file = "CarActualOwnerForm.vue"
export default component.exports